import React, { Component } from 'react';

class LocationSelect extends Component {
  state = {
    sliderDistance: 1,
    sliderResults: 10,
  }

  render() {
    console.log(this.state)
    return (
      <div >
        <h3>
          Search radius:
      </h3>
        <input onChange={this.handleSliderDistanceChange} type="range" min="-5" max="10" value={this.state.sliderDistance} className="slider" id="myRange" />
        {/* <button onClick={() => this.props.updateInfo('distance', 1)}>1 mile</button>
        <button onClick={() => this.props.updateInfo('distance', 5)}>5 mile</button>
        <button onClick={() => this.props.updateInfo('distance', 10)}>10 miles</button> */}
        <h3>
          Number of results:
      </h3>
        <input onChange={this.handleSliderResultsChange} type="range" min="1" max="50" value={this.state.sliderResults} className="slider" id="myRange2" />
        {/* <button onClick={() => this.props.updateInfo('maxresults', 10)}>10 locations</button>
        <button onClick={() => this.props.updateInfo('maxresults', 25)}>25 locations</button>
        <button onClick={() => this.props.updateInfo('maxresults', 50)}>50 locations</button> */}
      </div >
    );
  }



  handleSliderDistanceChange = (event) => {
    const { value } = event.target;
    this.setState({
      sliderDistance: value
    }, this.props.updateInfo('distance', value))
  }

  handleSliderResultsChange = (event) => {
    const { value } = event.target;
    this.setState({
      sliderResults: value
    }, this.props.updateInfo('maxresults', value))
  }

};

export default LocationSelect; 